// Quotation Rejected Stage  Btn related codes goes here

// NPM Imports
import React, { Component, Fragment } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Tooltip } from "@revvsales/components";

// Components Imports
// import ReferralPopup from "../../SettingsWrapper/ReferralPopup";
// import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";
// import UploadRevision from "./UploadRevision";
import QuotationBottomStages from "../../QuotationTopbar/QuotationBottomBar/QuotationBottomStages";
import SendForReview from "../../QuotationTopbar/QuotationTopbarBtns/SendForReview";
// import { USER_ROLES } from "../../../constants/roleList";
// import { GlobalUtils } from "../../../utils";

// Declarations

// Destructuring
// const { readDataFromLocalStorage } = GlobalUtils;

class QuotationSentAcceptorOwnerBtns extends Component {
  state = {
    // showReferralPopup: false,
  };

  _toggleNavbarPopup = (type, flag) => {
    this.setState({ [type]: flag });
  };

  render() {
    // const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    // let popupSpace = null;

    // if (this.state.showReferralPopup) {
    //   popupSpace = <ReferralPopup closePopup={this._toggleNavbarPopup} />;
    // }

    return (
      <Fragment>
        {/**
        {popupSpace}
        <Fragment>
          <div>
            <Tooltip placement="bottom" overlay="Refer and get benefits!">
              <span
                className="referral-wrapper"
                onClick={() =>
                  this._toggleNavbarPopup("showReferralPopup", true)
                }
                onKeyPress={() => {}}
                tabIndex="0"
                role="button">
                <span aria-label="referral-gift-wrapper" role="img">
                  🎁
                </span>
              </span>
            </Tooltip>
          </div>
          {CURRENT_USER.roles[0].name === USER_ROLES.ADMIN && (
            <div>
              <Tooltip placement="bottom" overlay="Invite team members to Revv">
                <span
                  className="user-role-wrapper"
                  onClick={() =>
                    this.props.togglePopUp("showTeammatePopup", true)
                  }
                  onKeyPress={() => {}}
                  tabIndex="0"
                  role="button">
                  <FontAwesomeIcon icon={["fas", "user-plus"]} />
                </span>
              </Tooltip>
            </div>
          )}
          <div className="user-invite-line" />
        </Fragment>
        {!this.props.showForm ? (
          <Tooltip
            placement="bottom"
            align={{
              offset: [0, 4],
            }}
            overlay="Document already sent for signature/acceptance.">
            <div>
              <Button
                className="revv-btn-disabled-esign"
                id={"signerDetails".replace(/ +/g, "-").toLowerCase()}>
                <FontAwesomeIcon
                  icon={["far", "signature"]}
                  className="documentrecipientlist-role-icon"
                />
                &nbsp; eSign
              </Button>
            </div>
          </Tooltip>
        ) : null}
         */}
        <QuotationBottomStages {...this.props} />
        <SendForReview {...this.props} />
        {/* <ExportDocumentBtn docStatus={this.props.docStatus} />
        <Button
          className="analyse-document"
          onClick={() =>
            this.props.togglePopUp("showConfirmMoveToDraftPopup", true)
          }
          id={"EditBtnWithRbac".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Edit document
        </Button> */}
        {/* <UploadRevision {...this.props} /> */}
      </Fragment>
    );
  }
}

export default QuotationSentAcceptorOwnerBtns;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationSentAcceptorOwnerBtns.js